import React from 'react';
import { Stack } from '@mui/material';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

/**
 * 초대 전용 링크로 접속시 보여주는 모달
 * @typedef {Object} props
 * @param {string} inviteOrgName
 * @param {string} titleText,
 * @param {string} bodyText
 * @returns
 */

const Alert = React.forwardRef((props, ref) => <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />);

function SignupInviteModal({ inviteOrgName, titleText, bodyText }) {
  return (
    <Stack spacing={2} sx={{ width: '100%' }}>
      <Snackbar open anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
        <Alert severity="success" sx={{ width: '100%' }}>
          {`${inviteOrgName} ${titleText}`}
          <br />
          {`${bodyText}`}
        </Alert>
      </Snackbar>
    </Stack>
  );
}

export default SignupInviteModal;
